import setup from './moduleSetup';

export default {
    name: 'selectors',
    before: [],
    after: [],
    setup,
};
